import serviceAreaAttributeApi from "@/api/serviceAreaAttribute";

export default {
  actions: {
    async create({ commit, dispatch, state }, data) {
      const record = await serviceAreaAttributeApi.create(data);
      commit("setRecord", record);
      await dispatch("list");

      return state.record;
    },
    async list({ commit }) {
      const response = await serviceAreaAttributeApi.list();
      commit("setList", response.data.result);
    },
    async update({ commit, dispatch, state }, data) {
      const record = await serviceAreaAttributeApi.update(data);
      commit("setRecord", record);
      await dispatch("list");
      return state.record;
    },
  },
  getters: {
    listByCategory: state => categoryId => {
      return state.list.filter(attribute => {
        return attribute.categoryId === categoryId;
      });
    },
    getById: state => findId => {
      return state.list.find(item => {
        return item.id === findId;
      });
    },
  },
  mutations: {
    setRecord(state, attribute) {
      state.record = attribute;
    },
    setList(state, list) {
      state.list = list;
    },
  },
  namespaced: true,
  state: {
    list: [],
    record: {},
  },
};
